import { Badge } from '@/components/ui/badge';

interface TagsDisplayCellProps {
  tags: string[];
  maxVisible?: number;
  emptyText?: string;
}

/**
 * Displays tags in a table cell with truncation
 * Shows first N tags and a "+X more" badge if there are more
 */
export function TagsDisplayCell({
  tags,
  maxVisible = 2,
  emptyText = '-'
}: TagsDisplayCellProps) {
  if (!tags || tags.length === 0) {
    return <span className="text-muted-foreground">{emptyText}</span>;
  }

  return (
    <div className="flex flex-wrap gap-1">
      {tags.slice(0, maxVisible).map((tag, i) => (
        <Badge key={i} variant="secondary" className="text-xs">
          {tag}
        </Badge>
      ))}
      {tags.length > maxVisible && (
        <Badge variant="secondary" className="text-xs">
          +{tags.length - maxVisible}
        </Badge>
      )}
    </div>
  );
}
